import React from "react";
import bankruptcy from "../../components/bankruptcy.jpeg";
import pdf1 from "./FreezeLexisNexis.pdf";
import pdf2 from "./Freezeyourcreditbeforesubmittingrepairletters.pdf";
import pdf3 from "./A_Letter1_Equifax_v2.doc.pdf";
import pdf4 from "./A_Letter2_Equifax_v2.doc.pdf";
import pdf5 from "./A_Letter3_Equifax_v2.doc.pdf";
import pdf6 from "./BANKRUPTCYACCOUNTSNOTIDENTIFIED.pdf";
import pdf7 from "./HowtoRemoveBankruptcyandOtherPublicRecords.pdf";
import pdf8 from "./REMOVEBANKRUPTCYFROMYOURCREDITREPORTS.pdf";

function Bankruptcy() {
  return (
    <div className="container">
      <div className="banner">
        <img src={bankruptcy} alt="" />
      </div>
      <div className="container_body">
        <div className="course">
          <h1>Bankruptcy Removal</h1>
          <p>
            Leverage these documents to accelerate Bankruptcy Removals. Download
            the resources provided in this module for your reference. As always
            the latest information can be found here and in our Google Drive:{" "}
            <a href="https://drive.google.com/drive/folders/1jF2V3clgkwJT6Ha_93WkYcVtZ8g32-6P?usp=drive_link">
              Bankruptcy Removal
            </a>
          </p>
        </div>
        <div className="downloads">
          <h3>Downloads</h3>
          <a href={pdf8}>REMOVE BANKRUPTCY FROM YOUR_CREDIT_REPORTS.pdf</a>
          <a href={pdf7}>
            How to Remove Bankruptcy and Other Public_Records.docx.pdf
          </a>
          <a href={pdf6}>BANKRUPTCY_ACCOUNTS NOT_IDENTIFIED.pdf</a>
          <a href={pdf3}> A_Letter1 Equifax_v2.doc.pdf</a>
          <a href={pdf4}>A_Letter2_Equifax_v2.doc.pdf</a>
          <a href={pdf5}>A_Letter3_Equifax_v2.doc.pdf</a>
          <a href={pdf2}>
            Freeze_your_credit_before_submitting repair_letters.pdf
          </a>
          <a href={pdf1}>Freeze_LexisNexis.docx.pdf</a>
        </div>
      </div>
    </div>
  );
}

export default Bankruptcy;
